export default "__VITE_ASSET__BPtBZhwb__"